import axios from 'axios';
import { attachRequestInterceptor } from './request-interceptor';
import { attachResponseInterceptor } from './response-interceptor';
const baseURL = process.env.REACT_APP_API_URL;
export const itwApi = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});
// Attach middleware interceptors
attachRequestInterceptor(itwApi);
attachResponseInterceptor(itwApi);
